module.exports = __webpack_public_path__ + "static/media/fondo.d361ff8c.jpg";